import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";

export function useIsClipboardScoreFrozen(workerId: string) {
  const { data: clipboardScoreProfile } = useGetClipboardScoreProfile(workerId);
  return clipboardScoreProfile?.scoreFreeze ?? { enabled: false };
}
